var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-vr"},[_c('div',{staticClass:"close iconfont icon-close",on:{"click":_vm.hide}}),_c('van-loading'),(_vm.show)?_c('iframe',{attrs:{"id":"myframe","src":_vm.frameSrc,"frameborder":"0"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }